import React, { useState, useContext, useEffect } from "react";
import DynamicIcon from "../../components/dynamicicon";
import JisButton from "../../components/controls/jisButton";
import JisCheckbox from "../../components/controls/jisCheckbox";
import { ShareContext } from "../../context/ShareContext";
import * as Constants from "../../constants";
import * as Services from "../../services";
import JisTabButton from "../../components/controls/jisTabButton";
import BackLoader from "../../components/backloader";
import JisDialog from "../../components/dialog";
import JisDialogForm from "../../components/formdialog";
import { useStepContext } from "@mui/material";
import TiptapEditor from "../../components/controls/tip_tap_editor";
import Papa from 'papaparse';

function CMSSetup() {
  const { activePage, token, setIsExpired, setAlert, frequentData } =
    useContext(ShareContext);
  const [page, setPage] = useState(null);
  const [tab, setTab] = useState("gallery");
  const [news, setNews] = useState({ id: 0 });
  const [gallery, setGallery] = useState({ id: 0, isSlider: 0 });
  const [galleryLine, setGalleryLine] = useState({ id: 0, rank: 1 });
  const [team, setTeam] = useState({ id: 0 });

  const [newsList, setNewsList] = useState([]);
  const [galleries, setGalleries] = useState([]);
  const [galleryLines, setGalleryLines] = useState([]);
  const [teams, setTeams] = useState([]);
  const [isDialog, setIsDialog] = useState(false);
  const [html, setHtml] = useState("");
  const [isLine, setIsLine] = useState(false);

  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [sFile, setSFile] = useState(null);
  const [previewPath, setPreviewPath] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [causeList, setCauseList] = useState({id:0});
  const [causeLists, setCauseLists] = useState([]);
  const [isUploadcsv, setIsUploadcsv] = useState(false);  
  const [csvfile, setCsvFile] = useState(null);
  const [csvCauselists, setCsvCauselists] = useState([]);

  //const docPath= `${Constants.docUrl}cms`;

  useEffect(() => {
    if (tab == "gallery" && !isLine && galleries.length == 0) {
      console.log("gallery and not isline ");
      onLoadGallery();
    } else if (tab == "gallery" && isLine) {
      console.log("gallery and isline ");
      onLoadGalleryLine();
    } else if (tab == "news" && newsList.length == 0) {
      setIsLine(false);
      onLoadNews();
    } else if (tab == "team" && teams.length == 0) {
      setIsLine(false);
      onLoadTeams();
    }else if (tab == "causelist" && causeLists.length == 0) {
      setIsLine(false);
      onLoadCauseLists();
    }
  }, [tab, isLine]);

  const newsTypes = [
    { value: "Innovation", label: "Innovation" },
    { value: "Events", label: "Events" },
    { value: "Other", label: "Other" },
  ];
  const onNewsChange = (e) => {
    setNews({ ...news, [e.target.name]: e.target.value });
  };
  const onGalleryChange = (e) => {
    setGallery({ ...gallery, [e.target.name]: e.target.value });
  };
  const onGalleryLineChange = (e) => {
    setGalleryLine({ ...galleryLine, [e.target.name]: e.target.value });
  };
  const onTeamChange = (e) => {
    setTeam({ ...team, [e.target.name]: e.target.value });
  };
  const onCauseListChange = (e) => {
    setCauseList({ ...causeList, [e.target.name]: e.target.value });
  };

  const onLoadGallery = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/gallery`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setGalleries(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadGalleryLine = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/cms/gallery/${gallery.id}/lines`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setGalleryLines(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadTeams = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/team`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setTeams(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadNews = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/news`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setNewsList(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
 const onLoadCauseLists = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/admin-cause-list`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCauseLists(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onAdd = () => {
    console.log(`${tab} the current tab`);
    setSFile(null);
    setIsDialog(true);
  };
  const onClose = () => {
    setIsDialog(false);
    setGallery({ id: 0, isSlider: 0 });
    setGalleryLine({ id: 0, rank: 1 });
    setTeam({ id: 0 });
    setNews({ id: 0 });
    setCauseList({id:0});
  };
  const onEdit = (obj, index) => {
    console.log(obj);
    if (tab == "gallery" && !isLine) {
      setGallery(obj);
    } else if (tab == "gallery" && isLine) {
      setGalleryLine(obj);
    } else if (tab == "news") {
      setNews(obj);
      setHtml(Constants.b64decode(obj.fullNote));
    } else if (tab == "team") {
      setTeam(obj);
    } else if (tab == "causelist") {
      setCauseList(obj);
    }
    setIsDialog(true);
  };
  const handleUploadChange = async (e) => {
    const files = e.target.files;
    console.log(files[0]);
    var b64 = await Constants.toBase64(files[0]);
    var path = URL.createObjectURL(files[0]);
    var fname = Constants.ReduceFilename(files[0]?.name);

    var a = {
      path,
      base64: b64.split(",")[1],
      filename: fname,
      base64Ext: b64.split(",")[0],
    };
    setSFile(a);
  };
  const onPreview = (obj) => {
    setIsPreview(true);
    setPreviewPath(obj.path);
  };
  const onReset = () => {
    setIsDialog(false);
    setSFile(null);
    if (tab == "gallery" && !isLine) {
      setGallery({ id: 0, isSlider: 0 });
      onLoadGallery();
    }
    if (tab == "gallery" && isLine) {
      setGalleryLine({ id: 0, rank: 1 });
      onLoadGalleryLine();
    }
    if (tab == "news") {
      setNews({ id: 0 });
      onLoadNews();
    }
    if (tab == "team") {
      setTeam({ id: 0 });
      onLoadTeams();
    }
    if (tab == "causelist") {
      setCauseList({ id: 0 });
      onLoadCauseLists();
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    var saveurl = "";
    var obj = null;
    if (tab == "gallery" && !isLine) {
      saveurl = `${Constants.apiUrl}/cms/gallery`;
      obj = {
        filename: sFile?.filename,
        coverImage: sFile?.base64,
        eventOn: gallery.eventOn,
        title: gallery.title,
        isActive: gallery.isActive,
        isSlider: gallery.isSlider,
        id: gallery.id,
      };
    }
    if (tab == "gallery" && isLine) {
      saveurl = `${Constants.apiUrl}/cms/gallery-line/${gallery.id}`;
      obj = {
        filename: sFile?.filename,
        coverImage: sFile?.base64,
        note: galleryLine.note,
        title: galleryLine.title,
        isActive: galleryLine.isActive,
        id: galleryLine.id,
        rank: galleryLine.rank,
      };
    }
    if (tab == "news") {
      saveurl = `${Constants.apiUrl}/cms/news`;
      obj = {
        filename: sFile?.filename,
        coverImage: sFile?.base64,
        fullnote: Constants.b64encode(html),
        subTitle: news.subTitle,
        title: news.title,
        isActive: news.isActive,
        isHighlight: news.isHighlight,
        id: news.id,
        newsOn: news.newsOn,
        newsType: news.newsType == "Other" ? news.other : news.newsType,
      };
    }
    if (tab == "team") {
      saveurl = `${Constants.apiUrl}/cms/team`;
      obj = {
        filename: sFile?.filename,
        coverImage: sFile?.base64,

        fullName: team.fullName,
        position: team.position,
        category: team.category == "Other" ? team.other : team.category,
        timeframe: team.timeframe,
        currentStatus: team.currentStatus,
        isActive: team.isActive,
        teamLocation: team.teamLocation,
        id: team.id,
      };
    }
    if (tab == "causelist") {
      saveurl = `${Constants.apiUrl}/cms/cause-list`;
      obj = {
         suitNumber : causeList.suitNumber,
        parties : causeList.parties?.Trim(),
        caseClassification : causeList.caseClassification?.Trim(),
        judge : causeList.judge?.Trim(),
        courtRoomNo : causeList.courtRoomNo?.Trim(),
        judicialDivision : causeList.judicialDivision?.Trim(),
        status : causeList.status?.Trim(),
        date : causeList.date?.Trim(),
        isActive : causeList.isActive
      };
    }

    setLoading(true);
    fetch(saveurl, {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          onReset();
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };
  const onSaveCsv = async (e) => {
    e.preventDefault();
    setLoading(true);
    const saveurl = `${Constants.apiUrl}/cms/cause-list-range`;
    fetch(saveurl, {
      method: "POST",
      body: JSON.stringify(csvCauselists),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          setIsUploadcsv(false);
          onReset();
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  }

  const onShowLine = (obj) => {
    setGallery(obj);
    setIsLine(true);
  };


const transformToCauseList = (data) => {
  return data.map((item, index) => {
    // Helper function to safely get value
    const getValue = (key) => {
      return (item[key] || '').replace(/^"|"$/g, '').trim();
    };
    
    // Get all fields
    let suitNumber = getValue("SUIT NUMBER");
    let parties = getValue("PARTIES");
    let caseClassification = getValue("CASE CLASSIFICATION");
    let judge = getValue("JUDGE");
    let dateStr = (getValue("DATE") || getValue("DATE (MM/DD/YYYY)"));
    let courtRoomNo = getValue("COURT ROOM NO.");
    let judicialDivision = getValue("JUDICIAL DIVISION");
    let status = getValue("STATUS");
    
    // If COURT ROOM NO. is empty, check if there's a "COURT 2" field
    if (!courtRoomNo && item["COURT 2"]) {
      courtRoomNo = getValue("COURT 2");
    }
    
    // If still empty, try to find any field that starts with "COURT"
    if (!courtRoomNo) {
      for (const key of Object.keys(item)) {
        if (key && key.toUpperCase().includes('COURT') && item[key]) {
          courtRoomNo = getValue(key);
          break;
        }
      }
    }
    
    // Parse the date
    let parsedDate = null;
    if (dateStr) {
      parsedDate = parseDate(dateStr);
    }
    
    // Log if missing data
    if (!suitNumber && !parties) {
      console.log(`Row ${index + 1} appears empty:`, item);
    }
    
    return {
      suitNumber: suitNumber || '',
      parties: parties || '',
      caseClassification: caseClassification || '',
      judge: judge || '',
      courtRoomNo: courtRoomNo || '',
      judicialDivision: judicialDivision || '',
      status: status || '',
      date: parsedDate,
    
      isActive: true
    };
  });
};
function parseDate(dateStr) {
  if (!dateStr) return null;
  
  // Clean the string
  let clean = dateStr.replace(/"/g, '').trim();
  
  // Remove ordinal indicators (st, nd, rd, th)
  clean = clean.replace(/(\d+)(st|nd|rd|th)/g, '$1');

  // Dates are built at midnight UTC: the server stores the value as sent, so a local
  // midnight in Lagos (UTC+1) would be saved as 23:00 on the previous day.
  const utcDate = (y, m, d) => new Date(Date.UTC(y, m, d));

  // Numeric dates: yyyy-mm-dd is what the template and Excel exports usually give.
  const iso = clean.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s].*)?$/);
  if (iso) {
    const d = utcDate(+iso[1], +iso[2] - 1, +iso[3]);
    return isNaN(d.getTime()) ? null : d;
  }
  // dd/mm/yyyy or mm/dd/yyyy: whichever part is over 12 is the day; when both could be the
  // month, MM/DD/YYYY is used, the same as the server-side CSV upload.
  const num = clean.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2}|\d{4})$/);
  if (num) {
    let a = +num[1], b = +num[2], y = +num[3];
    if (y < 100) y += 2000;
    let m = a, dd = b;
    if (a > 12 && b <= 12) { m = b; dd = a; }
    const d = utcDate(y, m - 1, dd);
    return d.getUTCMonth() === m - 1 && d.getUTCDate() === dd ? d : null;
  }
  
  // Handle common formats
  const monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 
                      'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
  
  const shortMonths = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 
                       'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  
  // Try to parse "MONDAY 6 JULY 2026" format
  const parts = clean.split(/[\s,]+/);
  let day = null;
  let month = null;
  let year = null;
  
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i].toUpperCase();
    
    // Check if it's a day (number 1-31)
    if (!isNaN(parseInt(parts[i])) && parseInt(parts[i]) >= 1 && parseInt(parts[i]) <= 31) {
      day = parseInt(parts[i]);
    }
    
    // Check if it's a month (full name or short name)
    const monthIndex = monthNames.findIndex(m => m === part);
    const shortMonthIndex = shortMonths.findIndex(m => m === part);
    
    if (monthIndex !== -1) {
      month = monthIndex;
    } else if (shortMonthIndex !== -1) {
      month = shortMonthIndex;
    }
    
    // Check if it's a year (4 digits)
    if (parseInt(parts[i]) >= 1900 && parseInt(parts[i]) <= 2100) {
      year = parseInt(parts[i]);
    }
  }
  
  // If we found month and day, create the date
  if (month !== null && day !== null) {
    const currentYear = year || new Date().getFullYear();
    const date = utcDate(currentYear, month, day);
    if (!isNaN(date.getTime())) {
      return date;
    }
  }
  
  // Try using JavaScript's Date parsing as fallback
  try {
    const date = new Date(clean);
    if (!isNaN(date.getTime())) {
      return date;
    }
  } catch (e) {
    // Continue to next method
  }
  
  // Try parsing with "MONDAY 6TH JULY" pattern (when year is in another column)
  const monthPattern = /([A-Z]+)\s+(\d+)\s+([A-Z]+)/i;
  const match = clean.match(monthPattern);
  if (match) {
    const monthName = match[3].toUpperCase();
    const dayNum = parseInt(match[2]);
    const monthIndex = monthNames.findIndex(m => m === monthName);
    if (monthIndex !== -1 && !isNaN(dayNum)) {
      const currentYear = new Date().getFullYear();
      const date = utcDate(currentYear, monthIndex, dayNum);
      if (!isNaN(date.getTime())) {
        return date;
      }
    }
  }
  
  console.warn('Could not parse date:', clean);
  return null;
}

function parseCSVLine(line) {
  const result = [];
  let current = '';
  let inQuotes = false;
  let i = 0;
  
  while (i < line.length) {
    const char = line[i];
    
    if (char === '"') {
      // Handle escaped quotes (double quotes inside quoted field)
      if (i + 1 < line.length && line[i + 1] === '"') {
        current += '"';
        i += 2; // Skip both quotes
        continue;
      }
      // Toggle quote mode
      inQuotes = !inQuotes;
      i++;
      continue;
    }
    
    if (char === ',' && !inQuotes) {
      // End of field
      result.push(current.trim());
      current = '';
      i++;
      continue;
    }
    
    current += char;
    i++;
  }
  
  // Push the last field
  result.push(current.trim());
  return result;
}

// Use with PapaParse for robust parsing


const handleFileChange = (e) => {
  const selectedFile = e.target.files[0];
  
  if (selectedFile) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      
      // PapaParse handles quoted fields automatically
      const result = Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        trimHeaders: true,
        transformHeader: (header) => header.trim(),
        transform: (value) => value.trim(),
        // Handle quotes properly
        quotes: true,
        // If you have fields with commas
        delimiter: ','
      });
      
      const rows = result.data.filter(row => {
        return Object.values(row).some(value => value !== '');
      });
      
     // console.log('Parsed rows:', rows);
      const transformed = transformToCauseList(rows);
      //console.log('Transformed Cause List:', transformed);
      setCsvCauselists(transformed);
    };
    reader.readAsText(selectedFile);
  }
};

//for the public notice modal
  const [file, setFile] = useState(null);
  const [documentLink, setDocumentLink] = useState(null);

  const [message, setMessage] = useState("");

  // Check whether notice.pdf exists
  const checkNotice = async () => {
    try {
      const response = await fetch(
        `${Constants.apiUrl}/cms/notice-link`
      );

      if (response.ok) {
        const data = await response.json();
        setDocumentLink(data.link);
      } else {
        setDocumentLink(null);
      }
    } catch (error) {
      console.error("Error checking notice:", error);
      setDocumentLink(null);
    }
  };

  // Check when component loads
  useEffect(() => {
    checkNotice();
  }, []);

  // Upload notice.pdf
  const uploadNotice = async () => {
    if (!file) {
      setMessage("Please select a PDF document.");
      return;
    }

    if (file.type !== "application/pdf") {
      setMessage("Only PDF documents are allowed.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      setMessage("");

      const response = await fetch(
        `${Constants.apiUrl}/cms/upload-notice`,
        {
          method: "POST",
          body: formData,
           headers: {
        
        Authorization: `Bearer ${token}`,
      },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          typeof data === "string"
            ? data
            : data.message || "Upload failed."
        );
      }

      // Use the link returned by the server
      setDocumentLink(data.link);

      setFile(null);

      // Reset file input
      document.getElementById("noticePdf").value = "";

      setMessage("Notice uploaded successfully.");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Delete notice.pdf
  const deleteNotice = async () => {
    if (!window.confirm("Are you sure you want to delete the notice?")) {
      return;
    }

    try {
      setLoading(true);
      setMessage("");

      const response = await fetch(
        `${Constants.apiUrl}/cms/delete-notice`,
        {
          method: "POST",
           headers: {
        
        Authorization: `Bearer ${token}`,
      },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          typeof data === "string"
            ? data
            : data.message || "Delete failed."
        );
      }

      // Hide preview and delete button
      setDocumentLink(null);
      setFile(null);

      setMessage("Notice deleted successfully.");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };


 
//end of the public notice modal

  return (
    <div>
      <div className="tab_body">
        <div
          className="tab_section"
          style={{ display: "flex", gap: "20px", marginBottom: "20px" }}
        >
          <JisTabButton
            code="gallery"
            isActive={tab == "gallery"}
            title="Gallery"
            data={page}
            isRoleBased={false}
            onClick={() => setTab("gallery")}
          />
          <JisTabButton
            code="news"
            isActive={tab == "news"}
            title="News"
            data={page}
            isRoleBased={false}
            onClick={() => setTab("news")}
          />
          <JisTabButton
            code="team"
            isActive={tab == "team"}
            title="Team"
            data={page}
            isRoleBased={false}
            onClick={() => setTab("team")}
          /> 
          <JisTabButton
            code="causelist"
            isActive={tab == "causelist"}
            title="Cause List"
            data={page}
            isRoleBased={false}
            onClick={() => setTab("causelist")}
          />
          <JisTabButton
            code="notice"
            isActive={tab == "notice"}
            title="Public Notice"
            data={page}
            isRoleBased={false}
            onClick={() => setTab("notice")}
          />
        </div>
        {tab == "gallery" && !isLine && (
          <div className="tab_view">
            <div style={{ textAlign: "right" }}>
              {" "}
              <JisButton variant="plain" onClick={onAdd}>
                Add Gallery
              </JisButton>
            </div>
            <div className="table">
              <div class="section-cases">
                <span>Gallery</span>
                <span className="total">{galleries?.length}</span>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <table className="case-table">
                    <thead>
                      <tr>
                        <th className="col-id">SN</th>
                        <th className="col-title">Title</th>
                        <th>CoverImage</th>
                        <th>Event Date</th>
                        <th>Status</th>
                        <th>For Slider</th>

                        <th>Gallery</th>
                        <th className="col-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {galleries.map((g, i) => {
                        return (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{g.title}</td>
                            <td>
                              {" "}
                              <img
                                src={`${Constants.docUrl}/cms/gallery/${g.coverImage}`}
                                style={{ height: 50 }}
                              />{" "}
                            </td>
                            <td> {Constants.displayDate(g.eventOn)}</td>
                            <td>{g.isActive ? "Active" : "Inactive"}</td>
                            <td>
                              {g.isSlider ? "For Photo Slide" : "for Gallery"}
                            </td>
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onShowLine(g)}
                              >
                                The Lines
                              </JisButton>
                            </td>
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onEdit(g, i)}
                              >
                                Edit
                              </JisButton>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
        {tab == "gallery" && isLine && (
          <div className="tab_view">
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>{gallery.title}</div>
              <div style={{ textAlign: "right" }}>
                <JisButton variant="plain" onClick={() => setIsLine(false)}>
                  Back to Gallery
                </JisButton>
                <JisButton variant="plain" onClick={onAdd}>
                  Add Gallery Line
                </JisButton>
              </div>
            </div>

            <div className="table">
              <div class="section-cases">
                <span>Gallery Line</span>
                <span className="total">{galleryLines?.length}</span>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <table className="case-table">
                    <thead>
                      <tr>
                        <th className="col-id">SN</th>
                        <th className="col-title">Title</th>
                        <th>CoverImage</th>
                        <th className="col-title">Note</th>
                        <th>Status</th>
                        <th className="col-id">Rank</th>
                        <th className="col-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {galleryLines.map((g, i) => {
                        return (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{g.title}</td>
                            <td>
                              {" "}
                              <img
                                src={`${Constants.docUrl}/cms/gallery/${gallery.id}/${g.coverImage}`}
                                style={{ height: 50 }}
                              />
                            </td>
                            <td> {g.note}</td>
                            <td>{g.isActive ? "Active" : "Inactive"}</td>
                            <td>{g.rank}</td>
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onEdit(g, i)}
                              >
                                Edit
                              </JisButton>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
        {tab == "news" && (
          <div className="tab_view">
            <div style={{ textAlign: "right" }}>
              {" "}
              <JisButton variant="plain" onClick={onAdd}>
                Add News
              </JisButton>
            </div>
            <div className="table">
              <div class="section-cases">
                <span>News</span>
                <span className="total">{newsList?.length}</span>
              </div>
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-id">SN</th>
                    <th className="col-title">Title</th>
                    <th className="col-title">Sub Title</th>
                    <th>Cover Image</th>
                    <th className="col-medium">News Date</th>
                    <th>News Type</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {newsList.map((g, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{g.title}</td>
                        <td>{g.subTitle}</td>
                        <td>
                          {" "}
                          <img
                            src={`${Constants.docUrl}/cms/news/${g.coverImage}`}
                            style={{ height: 50 }}
                          />{" "}
                        </td>
                        <td>{Constants.displayDate(g.newsOn)}</td>
                        <td>{g.newsType}</td>
                        <td>
                          <JisButton onClick={() => onEdit(g, i)}>
                            Edit
                          </JisButton>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {tab == "team" && (
          <div className="tab_view">
            <div style={{ textAlign: "right" }}>
              {" "}
              <JisButton variant="plain" onClick={onAdd}>
                Add Team
              </JisButton>
            </div>
            <div className="table">
              <div class="section-cases">
                <span>Teams</span>
                <span className="total">{teams?.length}</span>
              </div>
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Full Name</th>
                    <th>Position</th>

                    <th className="col-medium">Category</th>
                    <th>Time frame</th>
                    <th className="col-medium">Location</th>
                    <th>Cover Image</th>
                    <th>Status</th>
                    <th>Active</th>
                  </tr>
                </thead>
                <tbody>
                  {teams.map((g, i) => {
                    return (
                      <tr>
                        <td>{g.fullName}</td>
                        <td>{g.position}</td>
                        <td>{g.category}</td>
                        <td>{g.timeframe}</td>
                        <td>{g.teamLocation}</td>
                        <td>
                          {" "}
                          {g.coverImage != null && (
                            <img
                              src={`${Constants.docUrl}/cms/team/${g.coverImage}`}
                              style={{ height: 50 }}
                            />
                          )}{" "}
                        </td>
                        <td>{g.currentStatus}</td>
                        <td>{g.isActive ? "Active" : "Inactive"}</td>
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onEdit(g, i)}
                          >
                            Edit
                          </JisButton>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {tab == "causelist" && (
          <div className="tab_view">
            <div style={{ textAlign: "right" }}>
              {" "}
              <JisButton variant="plain" onClick={onAdd}>
                Add Cause List
              </JisButton>
              <JisButton variant="plain" onClick={() => setIsUploadcsv(true)}>
                Upload Cause List CSV
              </JisButton>
            </div>
            <div className="table">
              <div class="section-cases">
                <span>Cause Lists</span>
                <span className="total">{causeLists?.length}</span>
              </div>
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-title">SuitNumber</th>
                    <th>Parties</th>
                    <th className="col-medium">CaseClassification</th>
                    <th>Judge</th>
                    <th className="col-medium">CourtRoomNo</th>
                    <th>JudicialDivision</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Active</th>
                  </tr>
                </thead>
                <tbody>
                  {causeLists.map((g, i) => {
                    return (
                      <tr>
                        <td>{g.suitNumber}</td>
                        <td>{g.parties}</td>
                        <td>{g.caseClassification}</td>
                        <td>{g.judge}</td>
                        <td>{g.courtRoomNo}</td>
                        <td>{g.judicialDivision}</td>
                        <td>{g.status}</td>
                        <td>{Constants.displayDate(g.date)}</td>
                        <td>{g.isActive ? "Active" : "Inactive"}</td>
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onEdit(g, i)}
                          >
                            Edit
                          </JisButton>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {tab == "notice" && (
          <div className="tab_view">
             <div className="notice-document">

     

      <div>
        <input
          id="noticePdf"
          type="file"
          accept=".pdf,application/pdf"
          onChange={(e) => {
            setFile(e.target.files?.[0] || null);
            setMessage("");
          }}
          disabled={loading}
        />

       
        <JisButton variant="plain" type="button" onClick={uploadNotice}  disabled={loading || !file}>
                {loading ? "Uploading..." : "Upload PDF"}
              </JisButton>
      </div>

      {/* Show only when notice.pdf exists */}
      {documentLink && (
        <div style={{ marginTop: "20px" }}>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px"
            }}
          >
            <strong>Current Notice</strong>

            <JisButton
              type="button" type="button"
              onClick={deleteNotice}
              disabled={loading}
            >
              {loading ? "Deleting..." : "Delete"}
            </JisButton>
            
          </div>

          {/* PDF Preview */}
          <iframe
            src={documentLink}
            title="Notice PDF"
            width="100%"
            height="600px"
            style={{
              border: "1px solid #ddd",
              borderRadius: "5px"
            }}
          />

        </div>
      )}

      {message && (
        <div style={{ marginTop: "10px" }}>
          {message}
        </div>
      )}

    </div>
  
      </div>)}
      </div>
      <BackLoader open={loading} />
      {isDialog && tab == "gallery" && !isLine && (
        <JisDialogForm title="Gallery" onClose={onClose}>
          <div>
            <form onSubmit={onSave}>
              <div className="input-group">
                <label>
                  {" "}
                  Title <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <input
                    placeholder="title"
                    name="title"
                    required={true}
                    value={gallery.title}
                    onChange={onGalleryChange}
                  />
                </div>
              </div>
              <div>
                {gallery.coverImage != null && gallery.coverImage != "" && (
                  <div>
                    <img
                      src={`${Constants.docUrl}/cms/gallery/${gallery.coverImage}`}
                      style={{ height: 200 }}
                    />
                  </div>
                )}
                <div className="btn-upload">
                  <input
                    type="file"
                    accept="image/*"
                    id={`file-upload-${0}`}
                    onChange={(e) => handleUploadChange(e)}
                  />
                  <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                    {sFile?.path == null
                      ? "Choose Cover Image"
                      : Constants.ReduceString(sFile?.filename, 30)}
                  </label>
                </div>
              </div>

              <div className="input-group">
                <label>
                  Event On <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <input
                    placeholder="Event On"
                    name="eventOn"
                    required={true}
                    value={gallery.eventOn}
                    type="date"
                    onChange={onGalleryChange}
                  />
                </div>
              </div>
              <JisCheckbox
                value={gallery.isActive}
                label="Active"
                onChange={(e) => setGallery({ ...gallery, isActive: e })}
              />
              <JisCheckbox
                value={gallery.isSlider}
                label="Check if this is for Slider"
                onChange={(e) => setGallery({ ...gallery, isSlider: e })}
              />

              <div>
                <JisButton type="submit">
                  {gallery.id == 0 ? "Save" : "Update"}
                </JisButton>
              </div>
            </form>
          </div>
        </JisDialogForm>
      )}
      {isDialog && tab == "gallery" && isLine && (
        <JisDialogForm title="Gallery Line" onClose={onClose}>
          <div>
            <form onSubmit={onSave}>
              <div className="input-group">
                <label>
                  {" "}
                  Title <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <input
                    placeholder="title"
                    name="title"
                    required={true}
                    value={galleryLine.title}
                    onChange={onGalleryLineChange}
                  />
                </div>
              </div>
              <div>
                {galleryLine.coverImage != null &&
                  galleryLine.coverImage != "" && (
                    <div>
                      <img
                        src={`${Constants.docUrl}/cms/gallery/${gallery.id}/${galleryLine.coverImage}`}
                        style={{ height: 200 }}
                      />
                    </div>
                  )}
                <div className="btn-upload">
                  <input
                    type="file"
                    accept="image/*"
                    id={`file-upload-${0}`}
                    onChange={(e) => handleUploadChange(e)}
                  />
                  <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                    {sFile?.path == null
                      ? "Choose Cover Image"
                      : Constants.ReduceString(sFile?.filename, 30)}
                  </label>
                </div>
              </div>

              <div className="input-group">
                <label>
                  Note <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <input
                    placeholder="Note"
                    name="note"
                    required={true}
                    value={galleryLine.note}
                    onChange={onGalleryLineChange}
                  />
                </div>
              </div>
              <div className="input-group">
                <label>
                  Rank <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <input
                    placeholder="Rank in Number"
                    name="rank"
                    required={true}
                    value={galleryLine.rank}
                    onChange={onGalleryLineChange}
                  />
                </div>
              </div>
              <JisCheckbox
                value={galleryLine.isActive}
                label="Active"
                onChange={(e) =>
                  setGalleryLine({ ...galleryLine, isActive: e })
                }
              />

              <div>
                <JisButton type="submit">
                  {galleryLine.id == 0 ? "Save" : "Update"}
                </JisButton>
              </div>
            </form>
          </div>
        </JisDialogForm>
      )}

      {isDialog && tab == "news" && (
        <JisDialogForm title="News" onClose={onClose}>
          <form onSubmit={onSave}>
            <div className="input-group">
              <label> Title</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Title"
                  name="title"
                  value={news.title}
                  onChange={onNewsChange}
                  required={true}
                />
              </div>
            </div>
            <div className="input-group">
              <label>Sub Title</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Sub Title"
                  name="subTitle"
                  value={news.subTitle}
                  onChange={onNewsChange}
                  required={true}
                />
              </div>
            </div>
            <div>
              {news.coverImage != null && news.coverImage != "" && (
                <div>
                  <img
                    src={`${Constants.docUrl}/cms/news/${news.coverImage}`}
                    style={{ height: 200 }}
                  />
                </div>
              )}
              <div className="btn-upload">
                <input
                  type="file"
                  accept="image/*"
                  id={`file-upload-${0}`}
                  onChange={(e) => handleUploadChange(e)}
                />
                <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                  {sFile?.path == null
                    ? "Choose Cover Image"
                    : Constants.ReduceString(sFile?.filename, 30)}
                </label>
              </div>
            </div>
            <div className="input-group">
              <label>Full Note</label>
              <div className="input-wrapper">
                <div style={{ padding: "20px" }}>
                  <TiptapEditor
                    initialContent={html}
                    onChange={(content) => setHtml(content)}
                  />
                </div>
              </div>
            </div>
            <div className="select-group">
              <label>News Type:</label>
              <select
                name="newsType"
                value={news.newsType}
                onChange={onNewsChange}
                required
              >
                <option value="">Select </option>
                {newsTypes.map((opt, ind) => (
                  <option key={ind} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            {news.newsType == "Other" && (
              <div className="input-group">
                <label> Specity Type</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="person_3" />
                  <input
                    placeholder="Other Type"
                    name="other"
                    value={news.other}
                    onChange={onNewsChange}
                    required={true}
                  />
                </div>
              </div>
            )}

            <div className="input-group">
              <label>
                News On <span className="required">*</span>
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="phone_in_talk" />
                <input
                  placeholder="News on"
                  name="newsOn"
                  required={true}
                  value={news.newsOn}
                  type="date"
                  onChange={onNewsChange}
                />
              </div>
            </div>
            <JisCheckbox
              value={news.isHighlight}
              label="Is Highlight"
              onChange={(e) => setNews({ ...news, isHighlight: e })}
            />
            <JisCheckbox
              value={news.isActive}
              label="Active"
              onChange={(e) => setNews({ ...news, isActive: e })}
            />
            <div>
              <JisButton type="submit">
                {news.id == 0 ? "Save" : "Update"}{" "}
              </JisButton>
            </div>
          </form>
        </JisDialogForm>
      )}
      {isDialog && tab == "team" && (
        <JisDialogForm title="Team" onClose={onClose}>
          <form onSubmit={onSave}>
            <div className="input-group">
              <label> Full Name</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Full Name"
                  name="fullName"
                  value={team.fullName}
                  onChange={onTeamChange}
                  required={true}
                />
              </div>
            </div>
            <div>
              {team.coverImage != null && team.coverImage != "" && (
                <div>
                  <img
                    src={`${Constants.docUrl}/cms/team/${team.coverImage}`}
                    style={{ height: 200 }}
                  />
                </div>
              )}
              <div className="btn-upload">
                <input
                  type="file"
                  accept="image/*"
                  id={`file-upload-${0}`}
                  onChange={(e) => handleUploadChange(e)}
                />
                <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                  {sFile?.path == null
                    ? "Choose Cover Image"
                    : Constants.ReduceString(sFile?.filename, 30)}
                </label>
              </div>
            </div>
            <div className="input-group">
              <label>Position</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Position"
                  name="position"
                  value={team.position}
                  onChange={onTeamChange}
                  required={true}
                />
              </div>
            </div>
            <div className="select-group">
              <label>Category</label>
              <select
                name="category"
                value={team.category}
                onChange={onTeamChange}
                required
              >
                <option value="">Select Cateogry </option>
                <option value="Court Leadership">Court Leadership</option>
                <option value="Principal Officers">Principal Officers</option>
                <option value="Head of Unit">Head of Unit</option>
                <option value="Retired Chief Judges">
                  Retired Chief Judges
                </option>
                <option value="Retired Elevated Deceased Judges">
                  Retired Elevated Deceased Judges
                </option>
                <option value="Judges">Judges</option>
                <option value="Magistrates">Magistrate</option>
                <option value="Other">Other</option>
              </select>
            </div>
            {team.category == "Other" && (
              <div className="input-group">
                <label> Other Category</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="person_3" />
                  <input
                    placeholder="Other Category"
                    name="other"
                    value={team.other}
                    onChange={onTeamChange}
                    required={true}
                  />
                </div>
              </div>
            )}

            <div className="input-group">
              <label>Current Status</label>
              <div className="input-wrapper">
                <input
                  placeholder="Status eg Active, Retired, Deceased"
                  name="currentStatus"
                  value={team.currentStatus}
                  onChange={onTeamChange}
                />
              </div>
            </div>
            <div className="input-group">
              <label>Timeframe</label>
              <div className="input-wrapper">
                <input
                  placeholder="eg Oct 12, 1986 - Oct 14, 1994"
                  name="timeframe"
                  value={team.timeframe}
                  onChange={onTeamChange}
                />
              </div>
            </div>
            <div className="input-group">
              <label>Team Location</label>
              <div className="input-wrapper">
                <input
                  placeholder="eg Ikeja"
                  name="teamLocation"
                  value={team.teamLocation}
                  onChange={onTeamChange}
                />
              </div>
            </div>

            <JisCheckbox
              value={team.isActive}
              label="Active"
              onChange={(e) => setTeam({ ...team, isActive: e })}
            />
            <div>
              <JisButton type="submit">
                {team.id == 0 ? "Save" : "Update"}{" "}
              </JisButton>
            </div>
          </form>
        </JisDialogForm>
      )}
      {isDialog && tab == "causelist" && (
        <JisDialogForm title="Cause List" onClose={onClose}>
          <form onSubmit={onSave}>
            <div className="input-group">
              <label> Suit Number</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Suit Number"
                  name="Suit Number"
                  value={causeList.suitNumber}
                  onChange={onCauseListChange}
                  required={true}
                />
              </div>
            </div>
           
            <div className="input-group">
              <label>Parties</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Parties"
                  name="parties"
                  value={causeList.parties}
                  onChange={onCauseListChange}
                  required={true}
                />
              </div>
            </div>
            
        

            <div className="input-group">
              <label>Case Classification</label>
              <div className="input-wrapper">
                <input
                  placeholder="Case Classification"
                  name="caseClassification"
                  value={causeList.caseClassification}
                  onChange={onCauseListChange}
                />
              </div>
            </div>
            <div className="input-group">
              <label>judge</label>
              <div className="input-wrapper">
                <input
                  placeholder="Hon. Judge"
                  name="judge"
                  value={causeList.judge}
                  onChange={onCauseListChange}
                />
              </div>
            </div>
            <div className="input-group">
              <label>courtRoomNo</label>
              <div className="input-wrapper">
                <input
                  placeholder="eg Ikeja"
                  name="courtRoomNo"
                  value={causeList.courtRoomNo}
                  onChange={onCauseListChange}
                />
              </div>
            </div>
            <div className="input-group">
              <label>Judicial Division</label>
              <div className="input-wrapper">
                <input
                  placeholder="eg Ikeja"
                  name="judicialDivision"
                  value={causeList.judicialDivision}
                  onChange={onCauseListChange}
                />
              </div>
            </div>
            <div className="input-group">
              <label>Status</label>
              <div className="input-wrapper">
                <input
                  placeholder="eg Active"
                  name="status"
                  value={causeList.status}
                  onChange={onCauseListChange}
                />
              </div>
            </div>
            <div className="input-group">
              <label>Date</label>
              <div className="input-wrapper">
                <input
                  placeholder="eg 2023-10-10"
                  name="date"
                  value={causeList.date}
                  onChange={onCauseListChange}
                />
              </div>
            </div>

            <JisCheckbox
              value={causeList.isActive}
              label="Active"
              onChange={(e) => setCauseList({ ...causeList, isActive: e })}
            />
            <div>
              <JisButton type="submit">
                {team.id == 0 ? "Save" : "Update"}{" "}
              </JisButton>
            </div>
          </form>
        </JisDialogForm>
      )}
{isUploadcsv && <JisDialogForm title="Upload Cause List" onClose={() => setIsUploadcsv(false)}>
  <span>Click below to upload the CSV file</span>
   <input
            type="file"
            onChange={handleFileChange}
            accept=".csv"
            className="w-full"
          /> 
          {csvCauselists.length > 0 && (
            <div>
              <h3>Uploaded Cause Lists: {csvCauselists.length}</h3>
              {csvCauselists.filter((c) => !c.date).length > 0 && (
                <div style={{ color: "#c62828", fontSize: 13 }}>
                  {csvCauselists.filter((c) => !c.date).length} row(s) have no readable DATE and will be saved without a date.
                  Use the format YYYY-MM-DD (e.g. 2026-10-27) in the DATE column.
                </div>
              )}
            </div>
          )}
          <JisButton onClick={onSaveCsv} disabled={csvCauselists.length==0}>
            Upload CSV
          </JisButton>
  </JisDialogForm>}
    </div>
  );
}

export default CMSSetup;
